import {Injectable} from '@angular/core';
import {Observable, ReplaySubject} from 'rxjs';
import {CountedAndPaginated} from '../interface/response/counted-and-paginated';
import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {FilterService} from './filter.service';
import {first, take} from 'rxjs/operators';
import {Uuid} from '../interface/response/uuid';
import {CommissionImportRow} from '../interface/commission-import-row';
import {ReportCustom} from "../interface/report-custom";

@Injectable({
  providedIn: 'root'
})
export class CommissionImportRowService {
  public readonly rowListSubject: ReplaySubject<CountedAndPaginated<CommissionImportRow>>
    = new ReplaySubject<CountedAndPaginated<CommissionImportRow>>(1);
  public readonly rowSetteledListSubject: ReplaySubject<CountedAndPaginated<any>>
    = new ReplaySubject<CountedAndPaginated<any>>(1);

  constructor(
    private httpClient: HttpClient,
    private filterService: FilterService,
  ) {
  }

  public loadList(
    page: number,
    pageSize: number,
    filters: object,
    sort?: { sortBy?: string; sortOrder?: string }
  ): void {
    this.httpClient.get(`/rest/crm/commission-import-row?page=${page + 1}` +
      `&pageSize=${pageSize}&sortBy=${sort.sortBy ?? ''}&sortOrder=${sort.sortOrder ?? ''}&`
      + this.filterService.parseFilters(filters))
      .pipe(
        first()
      )
      .subscribe({
        next: (result: CountedAndPaginated<CommissionImportRow>) => {
          this.rowListSubject.next(result);
        }, error: (error: HttpErrorResponse) => {
          this.rowListSubject.error(error);
        }
      });
  }

  public loadMassEditionList(
    page: number,
    pageSize: number,
    filters: object,
    sort?: { sortBy?: string; sortOrder?: string }
  ): Observable<CountedAndPaginated<CommissionImportRow>> {
    let url = `/rest/crm/commission-import-row?page=${page + 1}&pageSize=${pageSize}&filter[settlementNotClosed]=1&` +
      this.filterService.parseFilters(filters);
    if (sort?.sortBy && sort?.sortOrder) {
      url += `&sortBy=${encodeURIComponent(sort.sortBy)}&sortOrder=${encodeURIComponent(sort.sortOrder)}`;
    }
    return this.httpClient.get<CountedAndPaginated<CommissionImportRow>>(url).pipe(first());
  }


  public loadSettledList(
    page: number,
    pageSize: number,
    filters: object,
  ): void {
    this.httpClient.get(`/rest/crm/commission-import-row-settled?page=${page + 1}&pageSize=${pageSize}&`
      + this.filterService.parseFilters(filters))
      .pipe(
        first()
      )
      .subscribe({
        next: (result: CountedAndPaginated<any>) => {
          this.rowSetteledListSubject.next(result);
        }, error: (error: HttpErrorResponse) => {
          this.rowSetteledListSubject.error(error);
        }
      });
  }

  public downloadSettledReport(filters: any): Observable<Uuid> {
    return this.httpClient.post(`/rest/crm/commission-import-row-settled/method/report?`
      + this.filterService.parseFilters(filters), {})
      .pipe(first()) as Observable<Uuid>;
  }

  public downloadReport(filters: any): Observable<Uuid> {
    return this.httpClient.post(`/rest/crm/commission-import-row/method/report?`
      + this.filterService.parseFilters(filters), {})
      .pipe(first()) as Observable<Uuid>;
  }

  public get(commissionImportRowId: string): Observable<CommissionImportRow> {
    return this.httpClient.get(`/rest/crm/commission-import-row/${commissionImportRowId}`)
      .pipe(first()) as Observable<CommissionImportRow>;
  }

  public update(formData: any, commissionImportRowId: string): Observable<any> {
    return this.httpClient.put(`/rest/crm/commission-import-row/${commissionImportRowId}`, formData)
      .pipe(first());
  }

  public massEdit(formData: any): Observable<Uuid> {
    return this.httpClient.post(`/rest/crm/commission-import-row/method/mass-edit`, formData)
      .pipe(first()) as Observable<Uuid>;
  }

  public downloadCustomReport(filters: object): Observable<Uuid> {
    return this.httpClient.post(`/rest/crm/commission-import-row/custom/method/report?` + this.filterService.parseFilters(filters), {})
      .pipe(first()) as Observable<Uuid>;
  }

  public getCustomReportSettings(reportName: string): Observable<ReportCustom> {
    return this.httpClient.get(`/rest/crm/report/custom/settings/${reportName}`)
      .pipe(first()) as Observable<ReportCustom>
      ;
  }

  public sendCustomReportSettings(formData: object): Observable<any> {
    return this.httpClient.post('/rest/crm/report/custom/settings', formData)
      .pipe(take(1));
  }
}
